import { apiGet } from '../../../fetch/apiService';

export function getTeams() {
	return apiGet('teams');
}
